import { COOKIE_NAME_GLOBAL_REDIRECT_TARGET } from '~/types/cookieNames';
import type { StoryblokMultilink } from '~storyblok-types/storyblok';

type GlobalRedirectTarget = {
    url: string;
    platformContext: string;
};

export const useGlobalRedirectTarget = () => {
    const redirectTarget = useCookie<GlobalRedirectTarget | null>(COOKIE_NAME_GLOBAL_REDIRECT_TARGET, {
        secure: true,
        sameSite: 'lax',
        path: '/',
        maxAge: 60 * 60 * 24
    });

    const setFromStoryblokLink = (link: StoryblokMultilink, platformContext: string) => {
        if (link.linktype !== 'story') return;

        const url = useStoryblokUrl(link);
        if (url) {
            redirectTarget.value = { url, platformContext };
        }
    };

    return { redirectTarget, setFromStoryblokLink };
};
